import React from "react";

import { useAppType } from "utils";

import { CTAButton, Col, Icon, LinkMoreInfo, Row } from "components";

export const EmptyStatePanel = ({
  buttonIcon = "newItem",
  button,
  dataTestId = "",
  description,
  headline,
  icons,
  infoLink,
  link = "",
  small = false,
  onClick,
}) => {
  const appType = useAppType();

  return (
    <section data-testid={dataTestId}>
      <div className="empty-state-banner">
        <Row justify="space-between" align="bottom" gutter={0}>
          <Col sm={24} md={small ? 24 : 14}>
            {icons && (
              <Row>
                <Col>
                  {icons.map((icon, i) => (
                    <Icon
                      dataTestId={`empty-state-panel-icon-${i}`}
                      iconName={icon}
                      size={appType.desktop && !small ? "xxxl" : "xl"}
                      className="white-text"
                      key={i}
                    />
                  ))}
                </Col>
              </Row>
            )}
            {headline && (
              <Row>
                <Col>
                  <h1 data-testid="empty-state-panel-headline" className="white-text">
                    {headline}
                  </h1>
                </Col>
              </Row>
            )}
            {description && (
              <Row>
                <Col>
                  <p data-testid="empty-state-panel-description" className="white-text margin-0">
                    {description}
                  </p>
                  {infoLink && (
                    <LinkMoreInfo dataTestId="empty-state-panel-info-link" className="margin-top-100" theme="light" onClick={() => infoLink.onClick()}>
                      {infoLink.text}
                    </LinkMoreInfo>
                  )}
                </Col>
              </Row>
            )}
          </Col>
          <Col sm={0} md={small ? 0 : 2} />
          <Col sm={24} md={small ? 24 : 8} className={small ? "margin-top-200" : ""}>
            {button && <CTAButton icon={buttonIcon} dataTestId="empty-state-panel-link" text={button} url={link} onClick={onClick} />}
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default EmptyStatePanel;
